import { z } from 'zod';
export const graphicLogoPlacementValues = [
    'top-left',
    'top-center',
    'top-right',
    'center-left',
    'center',
    'center-right',
    'bottom-left',
    'bottom-center',
    'bottom-right',
];
export const graphicLogoPlacementSchema = z.enum(graphicLogoPlacementValues);
//# sourceMappingURL=graphic-logo.js.map